/**
 * Csv Schema of ResponsavelConfigWhatsapp
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'

/* TODO: review generated schema */
export class CsvResponsavelConfigWhatsappSchema extends Schema {
  readonly name = 'CsvResponsavelConfigWhatsapp'

  readonly fieldSet: FieldSet<ResponsavelConfigWhatsapp> = {
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    status: schema => schema.model.status?.$id ?? null,
    // TODO: define the attribute
    // whatsappStatus: (schema) => schema.model.whatsappStatus?.$id ?? null,
    ocorrencia: schema => schema.model.ocorrencia?.$id ?? null,
    idConfigWhatsappPk: schema => schema.model.idConfigWhatsappPk,
    mensagem: schema => schema.model.mensagem,
    ativo: schema => Helper.bool(schema.model.ativo),
    templateId: schema => schema.model.templateId,
  }
}
